var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSocialLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6362 14.0908C13.4395 14.0908 14.0908 13.4395 14.0908 12.6362C14.0908 11.8329 13.4395 11.1816 12.6362 11.1816C11.8329 11.1816 11.1816 11.8329 11.1816 12.6362C11.1816 13.4395 11.8329 14.0908 12.6362 14.0908Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0907 14.8184H11.1816V22.8184H14.0907V14.8184Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.75C8.02537 0.75 0.75 8.02537 0.75 17C0.75 25.9746 8.02537 33.25 17 33.25C25.9746 33.25 33.25 25.9746 33.25 17C33.25 8.02537 25.9746 0.75 17 0.75ZM17 31.2954C9.10482 31.2954 2.70456 24.8952 2.70456 17C2.70456 9.10482 9.10482 2.70456 17 2.70456C24.8952 2.70456 31.2954 9.10482 31.2954 17C31.2954 24.8952 24.8952 31.2954 17 31.2954Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8981 14.8184C18.7163 14.8184 18.4545 16.1129 18.4545 16.1129V14.8184H15.5454V22.8184H18.4545V18.4547C18.4545 18.4547 18.4545 17.0002 19.6908 17.0002C20.4181 17.0002 20.6363 17.6474 20.6363 18.4547V22.8184H23.5453V18.4547C23.5453 16.1784 22.5563 14.8184 20.8981 14.8184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialLinkedin);
export default __webpack_public_path__ + "static/media/icon_social_linkedin.fcf6c4639722586be0ce571c68cae3ba.svg";
export { ForwardRef as ReactComponent };